<template>
  <router-view />
</template>

<style lang="less">
html,
body,
header,
footer,
h1,
h2,
h3,
h4,
h5,
h6,
ul,
ol,
div {
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html,
body {
  height: 100%;
  font-family: sans-serif;
  background: #f5f5f5;
}
#app {
  height: 100%;
}
</style>
